<template>
  <div
    class="modal"
    :class="{
      'modal--is-ready': isReady,
      'modal--hold-timer': holdTimer,
      'modal--start-timer': startTimer,
      'modal--focused': isFocused && visible,
    }"
    :id="id"
    v-if="visible"
    role="dialog"
    @mouseenter="setFocus"
    @touchstart="setFocus"
    v-outside-click:[true]="close"
  >
    <div
      class="modal__header"
      :class="[headlineType ? `modal__header--${headlineType}` : '']"
      v-if="headline"
      v-html="headline"
    />
    <button
      class="modal__close-button"
      @click="close"
      :aria-label="$t('global.close')"
    />
    <div class="modal__content">
      <slot />
    </div>
  </div>
</template>

<script>
  import pigeon from '../../utilities/js/pigeon/pigeon.js';

  const VoucherHint = {
    name: 'voucher-hint',
    props: {
      id: String,
      headline: String,
      headlineType: String,
      initialVisible: {
        type: Boolean,
        default: false
      },
      autoCloseTimeout: {
        type: Number,
        default: 0
      },
      showOverlay: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: this.initialVisible,
        isReady: false,
        isFocused: false,
        autoCloseTimer: null,
        holdTimer: null,
        startTimer: null,
        overlayClass: !this.showOverlay ? 'page-overlay--transparent' : null,
      };
    },
    created() {
      pigeon.subscribe('voucherHint:startAutoCloseTimer', this.startAutoCloseTimer.bind(this));
    },
    mounted() {
      this.$nextTick(() => {
        this.isReady = true;
        this.checkAutoCloseTimer();
        if (this.showOverlay && this.visible) {
          pigeon.publish('pageoverlay:show', this.overlayClass);
        }
      });
    },
    methods: {
      open() {
        pigeon.publish('pageoverlay:show', this.overlayClass);
        this.visible = true;
        this.checkAutoCloseTimer();
      },
      close() {
        if (document.querySelector('.consent-cookie-box') || this.holdTimer) {
          return;
        }
        pigeon.publish('pageoverlay:hide', this.overlayClass);
        this.visible = false;
        this.clearAutoCloseTimer();
      },
      setFocus() {
        this.isFocused = true;
        this.startTimer = false;
        this.clearAutoCloseTimer();
      },
      checkAutoCloseTimer() {
        if (document.querySelector('.consent-cookie-box')) {
          this.holdTimer = true;
          this.setFocus();
          return;
        }
        this.startAutoCloseTimer();
      },
      startAutoCloseTimer() {
        document.body.classList.add('voucher-hint--start-timer');
        this.holdTimer = false;
        if (this.visible && this.showOverlay) {
          pigeon.publish('pageoverlay:show', this.overlayClass);
        }
        if (this.autoCloseTimeout > 0) {
          this.startTimer = true;
          this.isFocused = false;
          this.clearAutoCloseTimer();
          this.autoCloseTimer = setTimeout(() => {
            if (!this.isFocused) {
              this.close();
            }
          }, this.autoCloseTimeout);
        }
      },
      clearAutoCloseTimer() {
        if (this.autoCloseTimer) {
          document.body.classList.remove('voucher-hint--start-timer');
          document.body.classList.add('voucher-hint--is-closed');
          clearTimeout(this.autoCloseTimer);
          this.autoCloseTimer = null;
        }
      }
    },
    beforeDestroy() {
      this.clearAutoCloseTimer();
    }
  };

  export default VoucherHint;
</script>
